import {identity} from 'lodash';
import memoizeOne from 'memoize-one';

/*
 * Types.
 */

export type ValueStabilizer<T> = (value: T) => T;

/*
 * Stabilizer factories.
 */

/** Creates a memoization function that "stabilizes" a value in terms of its referential equality. */
export function createStabilizerCreator<T>(
  isEqual: (value: T, otherValue: T) => boolean,
): () => ValueStabilizer<T> {
  return () =>
    memoizeOne<ValueStabilizer<T>>(identity, ([value], [otherValue]) => isEqual(value, otherValue));
}
